<script>
  import { _ } from 'svelte-i18n'
  import { handleUpsell } from '../modules/helpers'
  import { modals, previews_are_zoomed, previews_are_google_fonts, preview_mode, user_valid, can_upgrade_from_pro_to_business, upload_storefront_modal_mode } from '../stores'
  import Button from '../elements/Button.svelte'
  import PreviewsTrackingStepper from './PreviewsTrackingStepper.svelte'

  function openUploadModal() {
    $upload_storefront_modal_mode = 'upload'
    modals.open('uploadOrAddToStorefront')
  }

  function openStorefrontModal() {
    $upload_storefront_modal_mode = 'addToStorefront'
    modals.open('uploadOrAddToStorefront')
  }
</script>

<div class="selectedActions" class:stickToTop={$previews_are_zoomed}>
  {#if !$previews_are_zoomed && !$previews_are_google_fonts}
    <span 
      on:click={() => handleUpsell('tag_button', true)}
      class:pro_only_no_demo={!$user_valid}>
        <Button size="small" on:click={() => modals.open('saveTag')}>{$_('buttons.tag')}</Button>
    </span>

    <span 
      on:click={() => handleUpsell('save_selection_button', true)}
      class:pro_only_no_demo={!$user_valid}>
        <Button size="small" on:click={() => modals.open('saveSelection')}>{$_('buttons.save')}</Button>
    </span>
  {/if}

  <span 
    on:click={() => handleUpsell('export', true)}
    class:pro_only={!$user_valid}>
    <Button size="small" on:click={() => modals.open('export_png')}>{$_('buttons.export')}</Button>
  </span>
  
  <span 
    on:click={() => handleUpsell('print', true)}
    class:pro_only={!$user_valid}>
    <Button size="small" on:click={() => modals.open('print')}>{$_('buttons.print')}</Button>
  </span>
  
  {#if $previews_are_zoomed && $preview_mode !== 'letters'}
    <PreviewsTrackingStepper/>
  {/if}
  
  {#if !$previews_are_zoomed && !$previews_are_google_fonts}
    <span 
      on:click={() => handleUpsell('upload_button', true)}
      class:business_only={!$user_valid || $can_upgrade_from_pro_to_business}
      class="spaced">
        <Button kind="outline" size="small" on:click={openUploadModal}>{$_('buttons.uploadToAccount')}</Button>
    </span>
    <span 
      on:click={() => handleUpsell('add_to_storefront_button', true)}
      class:business_only={!$user_valid || $can_upgrade_from_pro_to_business}>
        <Button kind="outline" size="small" on:click={openStorefrontModal}>{$_('buttons.addToStorefront')}</Button>
    </span>
  {/if}
</div>

<style>
  .selectedActions {
    display: flex;
    gap: 1rem;
  }
  .selectedActions span {
    position: relative;
  }
  
  .stickToTop {
    position: fixed;
    z-index: 5;
    top: 0;
    left: 0;
    width: 100%;
    padding: 0.6rem 1rem 1.4rem 1.8rem;
    background-color: var(--c-bg);    
  }
  span.spaced {
    margin-left: 1rem;
  }

  .selectedActions > :global(div) {
    display: inline-block;
    font-size: 1.6rem;
  }
</style>